import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#FFFBF5] border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_realty-vision-4/artifacts/xju4cezs_sara-realty-logo.png" 
                alt="Sara Realty" 
                className="h-12 w-auto"
              />
              <span className="font-heading text-2xl font-medium text-primary">Sara Realty</span>
            </Link>
            <p className="text-[#57534E] leading-relaxed">
              Invest for the lifetime of riches. Your trusted real estate partner in Tamil Nadu.
            </p>
          </div>

          <div>
            <h3 className="font-heading text-lg font-medium text-primary mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/properties" className="text-[#57534E] hover:text-primary transition-colors">Properties</Link></li>
              <li><Link to="/services" className="text-[#57534E] hover:text-primary transition-colors">Services</Link></li>
              <li><Link to="/about" className="text-[#57534E] hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-[#57534E] hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg font-medium text-primary mb-4">Services</h3>
            <ul className="space-y-2">
              <li><span className="text-[#57534E]">Buying & Selling</span></li>
              <li><span className="text-[#57534E]">Property Management</span></li>
              <li><span className="text-[#57534E]">Real Estate Consultancy</span></li>
              <li><span className="text-[#57534E]">Legal Assistance</span></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg font-medium text-primary mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-[#57534E]">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>Sakthi Enclave, No:4, 5th Main Road, Thilaiganganagar, Nanganallur, Chennai - 600 061</span>
              </li>
              <li className="flex items-center gap-3 text-[#57534E]">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <div className="flex flex-col">
                  <span>+91 97154 72526</span>
                  <span>+91 63808 03026</span>
                </div>
              </li>
              <li className="flex items-center gap-3 text-[#57534E]">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span>sararealtychennai@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-stone-200 text-center text-[#57534E]">
          <p>&copy; {new Date().getFullYear()} Sara Realty. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};